import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  last1vo29oleiqj36 as last,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  boxApply1qmzdb3dh90hg as boxApply,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$defaulthisepbk9rprr as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from '../encoding/Decoding.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  beginCollection27i47rk9upjw4 as beginCollection,
  encodeSerializableValue1mu7jsn2oheqi as encodeSerializableValue,
  encodeNullableSerializableValue22qo2euy9x1r4 as encodeNullableSerializableValue,
  shouldEncodeElementDefault1vy568gzcy4z0 as shouldEncodeElementDefault,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
} from '../encoding/Encoding.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NamedValueDecoderClass;
function NamedValueDecoder() {
  if (NamedValueDecoderClass === VOID) {
    class $ extends TaggedDecoder() {
      getTag_u4dqfb_k$(_this__u8e3s4, index) {
        return this.nested_cwsnxf_k$(this.elementName_p66hrm_k$(_this__u8e3s4, index));
      }
      nested_cwsnxf_k$(nestedName) {
        var tmp0_elvis_lhs = this.get_currentTagOrNull_yhyzw_k$();
        return this.composeName_8y2y4d_k$(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
      }
      elementName_p66hrm_k$(descriptor, index) {
        return descriptor.getElementName_u4sqmf_k$(index);
      }
      composeName_8y2y4d_k$(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) {
          tmp = childName;
        } else {
          tmp = parentName + '.' + childName;
        }
        return tmp;
      }
      renderTagStack_rja478_k$() {
        return this.tagStack_1.isEmpty_y1axqb_k$() ? '$' : joinToString(this.tagStack_1, '.', '$.');
      }
    }
    initMetadataForClass($, 'NamedValueDecoder');
    NamedValueDecoderClass = $;
  }
  return NamedValueDecoderClass;
}
var NamedValueEncoderClass;
function NamedValueEncoder() {
  if (NamedValueEncoderClass === VOID) {
    class $ extends TaggedEncoder() {
      static new_kotlinx_serialization_internal_NamedValueEncoder_pcvqd2_k$($box) {
        return this.new_kotlinx_serialization_internal_TaggedEncoder_65t4ny_k$($box);
      }
      getTag_u4dqfb_k$(_this__u8e3s4, index) {
        return this.nested_cwsnxf_k$(this.elementName_p66hrm_k$(_this__u8e3s4, index));
      }
      nested_cwsnxf_k$(nestedName) {
        var tmp0_elvis_lhs = this.get_currentTagOrNull_yhyzw_k$();
        return this.composeName_8y2y4d_k$(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
      }
      elementName_p66hrm_k$(descriptor, index) {
        return descriptor.getElementName_u4sqmf_k$(index);
      }
      composeName_8y2y4d_k$(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) {
          tmp = childName;
        } else {
          tmp = parentName + '.' + childName;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'NamedValueEncoder');
    NamedValueEncoderClass = $;
  }
  return NamedValueEncoderClass;
}
function tagBlock($this, tag, block) {
  $this.pushTag_bibnaf_k$(tag);
  var r = block();
  if (!$this.flag_1) {
    $this.popTag_g8zwqf_k$();
  }
  $this.flag_1 = false;
  return r;
}
var TaggedDecoderClass;
function TaggedDecoder() {
  if (TaggedDecoderClass === VOID) {
    class $ {
      constructor($box) {
        boxApply(this, $box);
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.tagStack_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.flag_1 = false;
      }
      get_serializersModule_piitvg_k$() {
        return EmptySerializersModule();
      }
      decodeTaggedValue_by1p0u_k$(tag) {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      decodeTaggedNotNullMark_opj0f8_k$(tag) {
        return true;
      }
      decodeTaggedBoolean_172rbv_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      decodeTaggedByte_y3phtl_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeTaggedShort_dapzw9_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeTaggedInt_mhypkc_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeTaggedLong_y9rqqb_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      decodeTaggedFloat_81o7o9_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeTaggedDouble_aa801q_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeTaggedChar_w7yrsn_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return tmp instanceof Char() ? tmp.value_1 : THROW_CCE();
      }
      decodeTaggedString_45pp1e_k$(tag) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      decodeTaggedEnum_iouca9_k$(tag, enumDescriptor) {
        var tmp = this.decodeTaggedValue_by1p0u_k$(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeTaggedInline_u4chc9_k$(tag, inlineDescriptor) {
        // Inline function 'kotlin.apply' call
        this.pushTag_bibnaf_k$(tag);
        return this;
      }
      decodeSerializableValue_8i9jjz_k$(deserializer, previousValue) {
        return this.decodeSerializableValue_xpnpad_k$(deserializer);
      }
      decodeInline_ux3vza_k$(descriptor) {
        return this.decodeTaggedInline_u4chc9_k$(this.popTag_g8zwqf_k$(), descriptor);
      }
      decodeNotNullMark_us4ba1_k$() {
        var tmp0_elvis_lhs = this.get_currentTagOrNull_yhyzw_k$();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var currentTag = tmp;
        return this.decodeTaggedNotNullMark_opj0f8_k$(currentTag);
      }
      decodeNull_jzrmuj_k$() {
        return null;
      }
      decodeBoolean_m0aca_k$() {
        return this.decodeTaggedBoolean_172rbv_k$(this.popTag_g8zwqf_k$());
      }
      decodeByte_jzz7je_k$() {
        return this.decodeTaggedByte_y3phtl_k$(this.popTag_g8zwqf_k$());
      }
      decodeShort_jjqk32_k$() {
        return this.decodeTaggedShort_dapzw9_k$(this.popTag_g8zwqf_k$());
      }
      decodeInt_8iq8f5_k$() {
        return this.decodeTaggedInt_mhypkc_k$(this.popTag_g8zwqf_k$());
      }
      decodeLong_jzt186_k$() {
        return this.decodeTaggedLong_y9rqqb_k$(this.popTag_g8zwqf_k$());
      }
      decodeFloat_jcnrwu_k$() {
        return this.decodeTaggedFloat_81o7o9_k$(this.popTag_g8zwqf_k$());
      }
      decodeDouble_ur8l0f_k$() {
        return this.decodeTaggedDouble_aa801q_k$(this.popTag_g8zwqf_k$());
      }
      decodeChar_dcmcfa_k$() {
        return this.decodeTaggedChar_w7yrsn_k$(this.popTag_g8zwqf_k$());
      }
      decodeString_x3hxsx_k$() {
        return this.decodeTaggedString_45pp1e_k$(this.popTag_g8zwqf_k$());
      }
      decodeEnum_slg6lu_k$(enumDescriptor) {
        return this.decodeTaggedEnum_iouca9_k$(this.popTag_g8zwqf_k$(), enumDescriptor);
      }
      beginStructure_yljocp_k$(descriptor) {
        return this;
      }
      endStructure_1xqz0n_k$(descriptor) {
      }
      decodeBooleanElement_vuyhtj_k$(descriptor, index) {
        return this.decodeTaggedBoolean_172rbv_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeByteElement_c1pisz_k$(descriptor, index) {
        return this.decodeTaggedByte_y3phtl_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeShortElement_pzg12t_k$(descriptor, index) {
        return this.decodeTaggedShort_dapzw9_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeIntElement_941u6a_k$(descriptor, index) {
        return this.decodeTaggedInt_mhypkc_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeLongElement_994anb_k$(descriptor, index) {
        return this.decodeTaggedLong_y9rqqb_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeFloatElement_p2q55h_k$(descriptor, index) {
        return this.decodeTaggedFloat_81o7o9_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeDoubleElement_isei84_k$(descriptor, index) {
        return this.decodeTaggedDouble_aa801q_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeCharElement_frbao3_k$(descriptor, index) {
        return this.decodeTaggedChar_w7yrsn_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeStringElement_3oenpg_k$(descriptor, index) {
        return this.decodeTaggedString_45pp1e_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      decodeInlineElement_s8883o_k$(descriptor, index) {
        return this.decodeTaggedInline_u4chc9_k$(this.getTag_u4dqfb_k$(descriptor, index), descriptor.getElementDescriptor_ncda77_k$(index));
      }
      decodeSerializableElement_uahnnv_k$(descriptor, index, deserializer, previousValue) {
        var tmp = this.getTag_u4dqfb_k$(descriptor, index);
        return tagBlock(this, tmp, () => this.decodeSerializableValue_8i9jjz_k$(deserializer, previousValue));
      }
      decodeNullableSerializableElement_k2y6ab_k$(descriptor, index, deserializer, previousValue) {
        var tmp = this.getTag_u4dqfb_k$(descriptor, index);
        return tagBlock(this, tmp, () => {
          // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
          var isNullabilitySupported = deserializer.get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$();
          var tmp;
          if (isNullabilitySupported || this.decodeNotNullMark_us4ba1_k$()) {
            tmp = this.decodeSerializableValue_8i9jjz_k$(deserializer, previousValue);
          } else {
            tmp = this.decodeNull_jzrmuj_k$();
          }
          return tmp;
        });
      }
      get_currentTagOrNull_yhyzw_k$() {
        return lastOrNull(this.tagStack_1);
      }
      pushTag_bibnaf_k$(name) {
        this.tagStack_1.add_utx5q5_k$(name);
      }
      popTag_g8zwqf_k$() {
        var r = this.tagStack_1.removeAt_6niowx_k$(get_lastIndex(this.tagStack_1));
        this.flag_1 = true;
        return r;
      }
    }
    protoOf($).decodeSerializableElement$default_j0zaoi_k$ = decodeSerializableElement$default;
    protoOf($).decodeSerializableValue_xpnpad_k$ = decodeSerializableValue;
    protoOf($).decodeSequentially_xlblqy_k$ = decodeSequentially;
    protoOf($).decodeCollectionSize_l3mlkk_k$ = decodeCollectionSize;
    initMetadataForClass($, 'TaggedDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    TaggedDecoderClass = $;
  }
  return TaggedDecoderClass;
}
function encodeElement($this, desc, index) {
  var tag = $this.getTag_u4dqfb_k$(desc, index);
  $this.pushTag_bibnaf_k$(tag);
  return true;
}
var TaggedEncoderClass;
function TaggedEncoder() {
  if (TaggedEncoderClass === VOID) {
    class $ {
      static new_kotlinx_serialization_internal_TaggedEncoder_65t4ny_k$($box) {
        var $this = createThis(this, $box);
        var tmp = $this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.tagStack_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return EmptySerializersModule();
      }
      encodeTaggedValue_uwjsrc_k$(tag, value) {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
      }
      encodeTaggedNonNullMark_nfwqvu_k$(tag) {
      }
      encodeTaggedNull_ef6rw0_k$(tag) {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('null is not supported');
      }
      encodeTaggedInt_sojdj8_k$(tag, value) {
        return this.encodeTaggedValue_uwjsrc_k$(tag, value);
      }
      encodeTaggedByte_zfi7rb_k$(tag, value) {
        return this.encodeTaggedValue_uwjsrc_k$(tag, value);
      }
      encodeTaggedShort_18vuif_k$(tag, value) {
        return this.encodeTaggedValue_uwjsrc_k$(tag, value);
      }
      encodeTaggedLong_j9j45b_k$(tag, value) {
        return this.encodeTaggedValue_uwjsrc_k$(tag, value);
      }
      encodeTaggedFloat_dhn4x5_k$(tag, value) {
        return this.encodeTaggedValue_uwjsrc_k$(tag, value);
      }
      encodeTaggedDouble_wxqx2s_k$(tag, value) {
        return this.encodeTaggedValue_uwjsrc_k$(tag, value);
      }
      encodeTaggedBoolean_96ly0o_k$(tag, value) {
        return this.encodeTaggedValue_uwjsrc_k$(tag, value);
      }
      encodeTaggedChar_o52n5u_k$(tag, value) {
        return this.encodeTaggedValue_uwjsrc_k$(tag, new (Char())(value));
      }
      encodeTaggedString_w0iev4_k$(tag, value) {
        return this.encodeTaggedValue_uwjsrc_k$(tag, value);
      }
      encodeTaggedEnum_vfihkh_k$(tag, enumDescriptor, ordinal) {
        return this.encodeTaggedValue_uwjsrc_k$(tag, ordinal);
      }
      encodeTaggedInline_k3uebz_k$(tag, inlineDescriptor) {
        // Inline function 'kotlin.apply' call
        this.pushTag_bibnaf_k$(tag);
        return this;
      }
      encodeInline_wxp5pu_k$(descriptor) {
        return this.encodeTaggedInline_k3uebz_k$(this.popTag_g8zwqf_k$(), descriptor);
      }
      encodeNotNullMark_415a1t_k$() {
        return this.encodeTaggedNonNullMark_nfwqvu_k$(this.get_currentTag_wui9re_k$());
      }
      encodeNull_ejiosz_k$() {
        return this.encodeTaggedNull_ef6rw0_k$(this.popTag_g8zwqf_k$());
      }
      encodeBoolean_tu2e59_k$(value) {
        return this.encodeTaggedBoolean_96ly0o_k$(this.popTag_g8zwqf_k$(), value);
      }
      encodeByte_6txfee_k$(value) {
        return this.encodeTaggedByte_zfi7rb_k$(this.popTag_g8zwqf_k$(), value);
      }
      encodeShort_gza6si_k$(value) {
        return this.encodeTaggedShort_18vuif_k$(this.popTag_g8zwqf_k$(), value);
      }
      encodeInt_y5zi3z_k$(value) {
        return this.encodeTaggedInt_sojdj8_k$(this.popTag_g8zwqf_k$(), value);
      }
      encodeLong_vlw3uq_k$(value) {
        return this.encodeTaggedLong_j9j45b_k$(this.popTag_g8zwqf_k$(), value);
      }
      encodeFloat_b8b85a_k$(value) {
        return this.encodeTaggedFloat_dhn4x5_k$(this.popTag_g8zwqf_k$(), value);
      }
      encodeDouble_n270q9_k$(value) {
        return this.encodeTaggedDouble_wxqx2s_k$(this.popTag_g8zwqf_k$(), value);
      }
      encodeChar_id8ngf_k$(value) {
        return this.encodeTaggedChar_o52n5u_k$(this.popTag_g8zwqf_k$(), value);
      }
      encodeString_424b5v_k$(value) {
        return this.encodeTaggedString_w0iev4_k$(this.popTag_g8zwqf_k$(), value);
      }
      encodeEnum_2qin0y_k$(enumDescriptor, index) {
        return this.encodeTaggedEnum_vfihkh_k$(this.popTag_g8zwqf_k$(), enumDescriptor, index);
      }
      beginStructure_yljocp_k$(descriptor) {
        return this;
      }
      endStructure_1xqz0n_k$(descriptor) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.tagStack_1.isEmpty_y1axqb_k$()) {
          this.popTag_g8zwqf_k$();
        }
        this.endEncode_mdsrgg_k$(descriptor);
      }
      endEncode_mdsrgg_k$(descriptor) {
      }
      encodeBooleanElement_ydht7q_k$(descriptor, index, value) {
        return this.encodeTaggedBoolean_96ly0o_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeByteElement_kft2ib_k$(descriptor, index, value) {
        return this.encodeTaggedByte_zfi7rb_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeShortElement_4bcdph_k$(descriptor, index, value) {
        return this.encodeTaggedShort_18vuif_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeIntElement_krhhce_k$(descriptor, index, value) {
        return this.encodeTaggedInt_sojdj8_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeLongElement_ovnxxh_k$(descriptor, index, value) {
        return this.encodeTaggedLong_j9j45b_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeFloatElement_oe8hn_k$(descriptor, index, value) {
        return this.encodeTaggedFloat_dhn4x5_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeDoubleElement_a6rqhe_k$(descriptor, index, value) {
        return this.encodeTaggedDouble_wxqx2s_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeCharElement_5nnekk_k$(descriptor, index, value) {
        return this.encodeTaggedChar_o52n5u_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeStringElement_1n5wu2_k$(descriptor, index, value) {
        return this.encodeTaggedString_w0iev4_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeInlineElement_69jjkk_k$(descriptor, index) {
        return this.encodeTaggedInline_k3uebz_k$(this.getTag_u4dqfb_k$(descriptor, index), descriptor.getElementDescriptor_ncda77_k$(index));
      }
      encodeSerializableElement_isqxcl_k$(descriptor, index, serializer, value) {
        if (encodeElement(this, descriptor, index)) {
          this.encodeSerializableValue_3uuzip_k$(serializer, value);
        }
      }
      encodeNullableSerializableElement_5lquiv_k$(descriptor, index, serializer, value) {
        if (encodeElement(this, descriptor, index)) {
          this.encodeNullableSerializableValue_ibrab1_k$(serializer, value);
        }
      }
      get_currentTag_wui9re_k$() {
        return last(this.tagStack_1);
      }
      get_currentTagOrNull_yhyzw_k$() {
        return lastOrNull(this.tagStack_1);
      }
      pushTag_bibnaf_k$(name) {
        this.tagStack_1.add_utx5q5_k$(name);
      }
      popTag_g8zwqf_k$() {
        var tmp;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.tagStack_1.isEmpty_y1axqb_k$()) {
          tmp = this.tagStack_1.removeAt_6niowx_k$(get_lastIndex(this.tagStack_1));
        } else {
          throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('No tag in stack for requested element');
        }
        return tmp;
      }
    }
    protoOf($).beginCollection_9edss2_k$ = beginCollection;
    protoOf($).encodeSerializableValue_3uuzip_k$ = encodeSerializableValue;
    protoOf($).encodeNullableSerializableValue_ibrab1_k$ = encodeNullableSerializableValue;
    protoOf($).shouldEncodeElementDefault_x8eyid_k$ = shouldEncodeElementDefault;
    initMetadataForClass($, 'TaggedEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    TaggedEncoderClass = $;
  }
  return TaggedEncoderClass;
}
//region block: exports
export {
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
  NamedValueEncoder as NamedValueEncoder1lca9edk1lf89,
};
//endregion

//# sourceMappingURL=Tagged.mjs.map
